class MobileSearchSummary extends HTMLElement {
    static observedAttributes: string[] = ['outbound', 'outbound-iata', 'inbound', 'inbound-iata', 'one-way', 'trip-duration'];
    private _hasRendered = false;

    constructor() {
        super();
    }

    attributeChangedCallback(attrName: string, oldValue: string, newValue: string) {
        if (newValue !== oldValue) {
            if (attrName === 'outbound') {
                this.outbound = newValue; // Explicitly call the setter
            } else if (attrName === 'outbound-iata') {
                this.outboundIATA = newValue; // Explicitly call the setter
            } else if (attrName === 'inbound') {
                this.inbound = newValue; // Explicitly call the setter
            } else if (attrName === 'inbound-iata') {
                this.inboundIATA = newValue; // Explicitly call the setter
            } else if (attrName === 'one-way') {
                this.oneWay = !(newValue === null); // Explicitly call the setter
            }

        }
    }

    connectedCallback() {
        const template = document.getElementById('mobile-search-summary-template') as HTMLTemplateElement;
        const clone = document.importNode(template.content, true);
        this.innerHTML = '';
        this.appendChild(clone);

        this._hasRendered = true;
        // Now that DOM is rendered, reflect current attributes into the DOM
        this._updateAllFields();
    }

    private _updateAllFields() {
        this._updateOutbound();
        this._updateOutboundIATA();
        this._updateInbound();
        this._updateInboundIATA();
        this._updateOneWay();
        this._updateTripDuration();
    }

    private _updateOutbound() {
        if (!this._hasRendered) return;
        this.querySelectorAll('[data-outbound]').forEach((el) => {
            el.textContent = this.outbound;
        });
    }

    private _updateOutboundIATA() {
        if (!this._hasRendered) return;
        this.querySelectorAll('[data-outbound-iata]').forEach((el) => {
            el.textContent = this.outboundIATA;
        });
    }

    private _updateInbound() {
        if (!this._hasRendered) return;
        this.querySelectorAll('[data-inbound]').forEach((el) => {
            el.textContent = this.inbound;
        });
    }

    private _updateInboundIATA() {
        if (!this._hasRendered) return;
        this.querySelectorAll('[data-inbound-iata]').forEach((el) => {
            el.textContent = this.inboundIATA;
        });
    }

    private _updateOneWay() {
        if (!this._hasRendered) return;
        const inboundSection = this.querySelector('[data-inbound-section]') as HTMLElement;
        if (inboundSection) {
            inboundSection.style.display = this.oneWay ? 'none' : '';
        }
    }

    private _updateTripDuration() {
        if (!this._hasRendered || !this.tripDuration) return;
        this.querySelectorAll('[data-trip-duration]').forEach((el) => {
            el.textContent = this.tripDuration;
        });
    }

    get outbound(): string {
        return this.getAttribute('outbound') || '';
    }

    set outbound(value: string) {
        this.setAttribute('outbound', value);
        this._updateOutbound();
    }

    get outboundIATA(): string {
        return this.getAttribute('outbound-iata') || '';
    }

    set outboundIATA(value: string) {
        this.setAttribute('outbound-iata', value);
        this._updateOutboundIATA();
    }

    get inbound(): string {
        return this.getAttribute('inbound') || '';
    }

    set inbound(value: string) {
        this.setAttribute('inbound', value);
        this._updateInbound();
    }

    get inboundIATA(): string {
        return this.getAttribute('inbound-iata') || '';
    }

    set inboundIATA(value: string) {
        this.setAttribute('inbound-iata', value);
        this._updateInboundIATA();
    }

    get oneWay(): boolean {
        return this.hasAttribute('one-way');
    }

    set oneWay(value: boolean) {
        this.toggleAttribute('one-way', value);
        this._updateOneWay();
    }

    get tripDuration(): string {
        return this.getAttribute('trip-duration') || '';
    }

    set tripDuration(value: string) {
        this.setAttribute('trip-duration', value);
        this._updateTripDuration();
    }
}

customElements.define('mobile-search-summary', MobileSearchSummary);
